import React, { useCallback, useState } from 'react';
import { View } from 'react-native';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Button, ButtonGroup } from 'app/src/elements/buttons';
import {
  Fields,
  defaultValues,
  prepareInput,
} from 'app/src/elements/hookForms';

import { FIELDS } from './new';
import { UPDATE_FEE_TYPE } from './queries';

const EditFeeType = ({ feeType, setShowModal, refetch }) => {
  const [formStatus, setFormStatus] = useState();

  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS, resource: feeType })
  });

  const [updateFeeType] = useMutation(UPDATE_FEE_TYPE, {
    onCompleted: () => {
      refetch();
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    setFormStatus('submitting');
    updateFeeType({ variables: prepareInput(input, FIELDS) });
  });

  return (
    <View>
      <Fields
        fields={FIELDS}
        control={control}
        errors={errors}
      />

      <ButtonGroup>
        <Button label="Update Fee Type" onPress={handleSubmit(onSubmit)} />
      </ButtonGroup>
    </View>
  );
};

export default EditFeeType;
